<footer class="site-footer" style="background-color: #ffffff; color: #4b5563; border-top: 1px solid #e5e7eb; padding: 10px 0; z-index: 99; transition: left 0.3s ease;">
  <div class="container" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; max-width: 1200px; margin: 0 auto; padding: 0 20px;">
    
    <!-- Logo Removed -->

    <!-- Address & Policies -->
    <div style="flex-grow: 1; text-align: center; font-size: 12px; color: #6b7280; display: flex; flex-direction: column; gap: 4px;">
      <div style="display: flex; justify-content: center; gap: 15px;">
        <a routerLink="/affiliate/terms" style="color: #6b7280; text-decoration: none; transition: color 0.2s;" onmouseover="this.style.color='#b97b00'" onmouseout="this.style.color='#6b7280'">{{ 'FOOTER.REGISTRATION_POLICY' | translate }}</a>
        <a routerLink="/affiliate/privacy" style="color: #6b7280; text-decoration: none; transition: color 0.2s;" onmouseover="this.style.color='#b97b00'" onmouseout="this.style.color='#6b7280'">{{ 'FOOTER.INFO_PRIVACY_POLICY' | translate }}</a>
        <a href="mailto:info&#64;11n02.com" style="color: #6b7280; text-decoration: none; transition: color 0.2s;" onmouseover="this.style.color='#b97b00'" onmouseout="this.style.color='#6b7280'">{{ 'FOOTER.SUPPORT_CONTACT' | translate }}</a>
      </div>
      <p style="margin: 0;">{{ 'FOOTER.COPYRIGHT_ADDRESS' | translate }}</p>
    </div>

    <!-- Right Side Actions -->
    <div style="flex-shrink: 0; display: flex; align-items: center; gap: 12px;">
      <div class="lang-switcher">
        <button mat-button [matMenuTriggerFor]="footerLangMenu" class="aff-lang-btn" style="display: inline-flex; align-items: center; gap: 4px; padding: 4px 8px; border: 1px solid #d1d5db; border-radius: 6px; background: transparent; color: #4b5563; font-size: 13px; font-weight: 500; cursor: pointer;" onmouseover="this.style.borderColor='#b97b00'; this.style.color='#b97b00';" onmouseout="this.style.borderColor='#d1d5db'; this.style.color='#4b5563';">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">language</mat-icon>
          <span>{{ (translationService.getCurrentLang() === 'vi' ? 'FOOTER.LANGUAGE_VI' : 'FOOTER.LANGUAGE_EN') | translate }}</span>
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">expand_more</mat-icon>
        </button>

        <mat-menu #footerLangMenu="matMenu" class="custom-lang-menu">
          <button mat-menu-item (click)="changeLang('vi')" [disabled]="translationService.getCurrentLang() === 'vi'">
            <span>{{ 'FOOTER.LANGUAGE_VI' | translate }}</span>
            <mat-icon *ngIf="translationService.getCurrentLang() === 'vi'">check</mat-icon>
          </button>
          <button mat-menu-item (click)="changeLang('en')" [disabled]="translationService.getCurrentLang() === 'en'">
            <span>{{ 'FOOTER.LANGUAGE_EN' | translate }}</span>
            <mat-icon *ngIf="translationService.getCurrentLang() === 'en'">check</mat-icon>
          </button>
        </mat-menu>
      </div>

      <a [href]="normalUserPageUrl" style="display: inline-flex; align-items: center; gap: 6px; color: #b97b00; text-decoration: none; font-weight: 500; font-size: 13px; padding: 6px 12px; border: 1px solid #b97b00; border-radius: 6px; transition: all 0.2s;" onmouseover="this.style.background='#b97b00'; this.style.color='white'" onmouseout="this.style.background='transparent'; this.style.color='#b97b00'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;">shopping_cart</mat-icon>
        {{ 'FOOTER.GO_TO_SHOP' | translate }}
      </a>
    </div>

  </div>
</footer>
<style>
.site-footer {
  position: static;
}

/* Adjust left position for desktop sidebar */
@media (min-width: 992px) {
  .site-footer {
    position: fixed;
    bottom: 0;
    left: 260px !important;
    right: 0;
  }
}
</style>
